// ============================================
// Utils - HTML Escape/Unescape (ES6)
// HTML 이스케이프 기능
// ============================================

export function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function unescapeHtml(text) {
  const div = document.createElement('div');
  div.innerHTML = text;
  return div.textContent || div.innerText || '';
}

// window 노출 제거됨 (2026-01-06) - import로 사용
